<template>
  <section>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">
      
      <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable :data="filteredData">
        <template #head>
          <th scope="col" class="px-6 py-3">ID</th>
          <th scope="col" class="px-6 py-3">Nome</th>
          <th scope="col" class="px-6 py-3">Especialidade</th>
          <th scope="col" class="px-6 py-3">Cidade</th>
          <th scope="col" class="px-6 py-3">#</th>
        </template>
      </DataTable>

    </div>
  </section>
</template>

<script setup>
import SearchInput from "@/components/Tables/SearchInput.vue";
import DataTable from "./../../components/_partials/DataTableMedicos.vue";
import AsosService from "../../service/asos.service";
import { showToast as toast } from '@/helpers/UseToasts'
import { computed, onBeforeMount } from "vue";
import { dataAso } from "../../store";
import { initFlowbite } from "flowbite";
import { ref } from "vue";

const store = dataAso;
const searchTerm = ref("");
const selectedFilter = ref("");

const dataTable = computed(() => {
  return store.getters?.getDocs.map((row) => {
    // 

    return {
      ...row
    };
  });
})

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable.value.filter((row) => {
    if(selectedFilter.value === 'Todos') 
    selectedFilter.value = '';

    const matchesSearch = !searchTerm.value || 
      ['nome', 'especialidade', 'cidade_id'].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesSearch;
  });
});
</script>
